import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GetUserProfileResponse, SaveUserProfileResponse, UserProfileModel } from 'src/app/_Models/useraccount/userprofile.model';
import { UserModel } from 'src/app/_Models/user/user.model';

@Injectable({
  providedIn: 'root'
})

export class UserProfileService {
  url: string
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl;

    if (this.url.charAt(this.url.length - 1) == '/')
      this.url = this.url.substring(0, this.url.length - 1);
  }

  async save(model: UserProfileModel) {
    const payload = {
      userId: model.userId,
      displayName: model.displayName,
      emailId: model.emailId,
      phone: model.phone,
      profileImageName: model.profileImageName,
      profileImageUrl: model.profileImageUrl,
      appLanguage: model.appLanguage,
      productGroupIds: model.selectedProductGroupIds || []
    };
    return await this.http.post<SaveUserProfileResponse>(`${this.url}/api/UserProfile`, payload).toPromise();
  }

  async getUserProfileSummary(userId: number) {
    return await this.http.get<GetUserProfileResponse>(`${this.url}/api/UserProfile/${userId}`).toPromise();
  }

  async getUser() {

    return await this.http.get<UserModel>(`${this.url}/api/User/userInfo`).toPromise();
  }

  async getLanguages() {
    return await this.http.get<any>(`${this.url}/api/UserProfile`).toPromise();
  }
  getClientInfo() {
    return this.http.get<any>(`${this.url}/api/User/clientInfo`);
  }
}
